<template>
  <div class="rb shadow mb concept-block">
    <div class="block-content">
      <div class="block-mastery" :class="color">
        {{ conceptMastery }}
      </div>
      <div class="block-text">
        <div class="bold">{{ conceptName }}</div>
        <div class="italic">
          {{
            `${
              color === "green"
                ? "Mastered Concept"
                : "Has not mastered concept"
            }`
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConceptBlock",
  props: {
    conceptName: {
      type: String,
      default: "Determining Fractions"
    },
    conceptMastery: {
      type: String,
      default: "3"
    },
    color: {
      type: String,
      default: "grey"
    }
  }
};
</script>
